/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cover_Letters_Label_ResumeInputs */

const en_cover_letters_label_resume = /** @type {(inputs: Cover_Letters_Label_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resume`)
};

const de_cover_letters_label_resume = /** @type {(inputs: Cover_Letters_Label_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lebenslauf`)
};

const fr_cover_letters_label_resume = /** @type {(inputs: Cover_Letters_Label_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV`)
};

const es_cover_letters_label_resume = /** @type {(inputs: Cover_Letters_Label_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Currículum`)
};

const it_cover_letters_label_resume = /** @type {(inputs: Cover_Letters_Label_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Curriculum Vitae`)
};

const nl_cover_letters_label_resume = /** @type {(inputs: Cover_Letters_Label_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV`)
};

const pl_cover_letters_label_resume = /** @type {(inputs: Cover_Letters_Label_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV`)
};

const fi_cover_letters_label_resume = /** @type {(inputs: Cover_Letters_Label_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansioluettelo`)
};

const da_cover_letters_label_resume = /** @type {(inputs: Cover_Letters_Label_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV`)
};

const sv_cover_letters_label_resume = /** @type {(inputs: Cover_Letters_Label_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV`)
};

/**
* | output |
* | --- |
* | "Resume" |
*
* @param {Cover_Letters_Label_ResumeInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const cover_letters_label_resume = /** @type {((inputs?: Cover_Letters_Label_ResumeInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cover_Letters_Label_ResumeInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cover_letters_label_resume(inputs)
	if (locale === "fr") return fr_cover_letters_label_resume(inputs)
	if (locale === "es") return es_cover_letters_label_resume(inputs)
	if (locale === "it") return it_cover_letters_label_resume(inputs)
	if (locale === "nl") return nl_cover_letters_label_resume(inputs)
	if (locale === "pl") return pl_cover_letters_label_resume(inputs)
	if (locale === "fi") return fi_cover_letters_label_resume(inputs)
	if (locale === "da") return da_cover_letters_label_resume(inputs)
	if (locale === "sv") return sv_cover_letters_label_resume(inputs)
	return en_cover_letters_label_resume(inputs)
});